export default "__VITE_ASSET__BiQt2sSi__"